import { InitialAssemblyState, InitialShadeState, updateAssembly } from "..";
import store from "../../..";
import { useUser } from "../../../user/hooks";
import { UseAssembly } from "../hooks";
import { AssemblyStore, CurrentIndoorShadeOptionsFunc, IndoorMountType, IndoorShadeConfiguration, IndoorMotorType, IndoorShadeOptionsAllDict, IndoorSideChannels, IndoorSideChannelsColor, IndoorShadeOptionsFunc, PortalShadeOptionItem, IndoorDriveType, IndoorManualChain, IndoorHembarType, IndoorHembarColor, IndoorLvPowerSource, IndoorManualChainColor, IndoorControlSide, IndoorHeaderType, IndoorBalancedLightgaps, IndoorHardwareColor, IndoorEndCaps, CardinalDirectionType, ShadeStore } from "../types";
import IndoorShadeOptionsCoupled from "./IndoorCoupledHooks";
import IndoorShadeOptionsDualCoupled from "./IndoorDualCoupledHooks";
import IndoorShadeOptionsDual from "./IndoorDualHooks";
import IndoorShadeOptionsSingle from "./IndoorSingleHooks";


import MotorizedShade from "../../../../assets/img/illus/motorized_shade.png";
import SpringPull from "../../../../assets/img/illus/spring_pull.png";
import ManualShade from "../../../../assets/img/illus/manual_shade.png";
import FabricWidth from "../../../../assets/img/illus/fabric_width.png";
import InsideMount from "../../../../assets/img/illus/inside_mount.png";
import OutsideMount from "../../../../assets/img/illus/outside_mount.png";
import RightControl from "../../../../assets/img/illus/right_control.png";
import LeftControl from "../../../../assets/img/illus/left_control.png";
import InternalFlatHembar from "../../../../assets/img/internal_flat_hembar.png";
import InternalRoundedHembar from "../../../../assets/img/internal_rounded_hembar.png";
import ExternalHembar from "../../../../assets/img/external_hembar.png";
import HembarWithMagnet from "../../../../assets/img/illus/magnet_hembar.png";
import SideChannels from "../../../../assets/img/illus/side_channels.png";
import SillPlate from "../../../../assets/img/illus/sill_plate.png";
import SideAndSill from "../../../../assets/img/illus/side_and_sill_channels.png";

import PoE from "../../../../assets/img/illus/poe-icon.png";
import AC from "../../../../assets/img/illus/ac-icon.png";
import DC from "../../../../assets/img/illus/dc-icon.png";
import Battery from "../../../../assets/img/illus/battery-icon.png";

import Cassette_3_FW_Single from '../../../../assets/img/Cassette_3_FW_Single.png';
import Fascia_3_Single from '../../../../assets/img/Fascia_3_Single.png';
import Fascia_5_Dual from '../../../../assets/img/Fascia_5_Dual.png';
import Fascia_5_Single from '../../../../assets/img/Fascia_5_Single.png';
import Open_Roll_Large_Dual from '../../../../assets/img/Open_Roll_Large_Dual.png';
import Open_Roll_Large_Single from '../../../../assets/img/Open_Roll_Large_Single.png';
import Open_Roll_Medium_Dual from '../../../../assets/img/Open_Roll_Medium_Dual.png';
import Open_Roll_Medium_Single from '../../../../assets/img/Open_Roll_Medium_Single.png';
import Open_Roll_Small_Single from '../../../../assets/img/Open_Roll_Small_Single.png';
// import Fascia_7_Dual from '../../assets/img/Fascia_7_Dual.png';
import Fascia_7_Dual from '../../../../assets/img/Fascia_7_Dual.png';
import { useIndoorFabrics } from "../../hooks";
import { useQuoteById } from "../../quotes/hooks";


const useCurrentIndoorShadeOptions: CurrentIndoorShadeOptionsFunc = (quoteId) => (sequenceId) => {
    const assembly = UseAssembly(quoteId, sequenceId) ?? InitialAssemblyState();

    const setAssembly = (assembly: AssemblyStore) => {
        store.dispatch(updateAssembly({
            assembly,
            quoteId,
            sequenceId
        }))
        console.log(assembly);
    }

    const indoorFabrics = useIndoorFabrics();
    const user = useUser();
    const quote = useQuoteById(quoteId);

    return useNewIndoorShadeOptions(assembly, setAssembly, {fabrics: indoorFabrics, user, quote});
}


// Generic Factory Function to make one list of options to rule them all. 
const useNewIndoorShadeOptions: IndoorShadeOptionsFunc = (assembly, setAssemblyInit, externalData, allOptionOverride = false) => {

    const {
        is_coupled,
        is_dual
    } = assembly;

    const isMotorized = assembly.shades[0]?.shade_type === "motorized";
    const isSpring = assembly.shades[0]?.manual_chain === "spring" && !isMotorized;
    const isFabricWidth = assembly.mount_type === "Fabric Width";

    const userData = externalData.user;
    const isPsAdmin = userData?.roles?.some(r => r.role_name == "powershades_admin") ?? false;
    // Hardcoded bidspec id. Still bad practice.
    const isBidspec = externalData.quote?.quote_type_id === 3;

    const baseDict = (is_coupled && is_dual) ? IndoorShadeOptionsDualCoupled(assembly, setAssemblyInit, externalData)
        : (is_coupled) ? IndoorShadeOptionsCoupled(assembly, setAssemblyInit, externalData)
            : (is_dual) ? IndoorShadeOptionsDual(assembly, setAssemblyInit, externalData)
                : IndoorShadeOptionsSingle(assembly, setAssemblyInit, externalData);


    // Header Mount Options by IndoorMountType
    const headerMountOptions: PortalShadeOptionItem<IndoorMountType>[] = [
        { label: "Inside", value: "Inside", title: "Inside" },
        { label: "Outside", value: "Outside", title: "Outside" },
        { label: "Fabric Width", value: "Fabric Width", title: "Fabric Width" }
    ];

    // Shade Configuration Options by IndoorShadeConfiguration
    const shadeConfigurationOptions: PortalShadeOptionItem<IndoorShadeConfiguration>[] = [
        { label: "Single", value: "single", title: "Single" },
        { label: "Dual", value: "dual", title: "Dual" },
        { label: "Coupled", value: "single coupled", title: "Coupled", isActive: !isSpring && !isFabricWidth },
        { label: "Dual Coupled", value: "dual coupled", title: "Dual Coupled", isActive: !isSpring && !isFabricWidth }
    ];

    // Direction Facing Options by string (North, South, East, West)
    const directionFacingOptions: PortalShadeOptionItem<CardinalDirectionType>[] = [
        { label: "North", value: "North", title: "North" },
        { label: "North West", value: "Northwest", title: "North West" },
        { label: "South", value: "South", title: "South" },
        { label: "South East", value: "Southeast", title: "South East" },
        { label: "East", value: "East", title: "East" },
        { label: "North East", value: "Northeast", title: "North East" },
        { label: "West", value: "West", title: "West" },
        { label: "South West", value: "Southwest", title: "South West" },
        { label: "Unknown", value: "Unknown", title: "Unknown" }
    ];

    // Side Channel Options by IndoorSideChannels
    const sideChannelOptions: PortalShadeOptionItem<IndoorSideChannels>[] = [
        { label: "None", value: "None", title: "None" },
        { label: "Side Channels", value: "Side Channels", title: "Side Channels" },
        { label: "Sill Channel", value: "Sill Channel", title: "Sill Channel" },
        { label: "Both", value: "Both", title: "Both" }
    ];

    // Side Channel Color Options by IndoorSideChannelsColor
    const sideChannelColorOptions: PortalShadeOptionItem<IndoorSideChannelsColor>[] = [
        { label: "White", value: "White", title: "White" },
        { label: "Black", value: "Black", title: "Black" },
        { label: "Anodized", value: "Anodized", title: "Anodized" }
    ];

    // Drive Type Options by IndoorDriveType
    const driveTypeOptions: PortalShadeOptionItem<IndoorDriveType>[] = [
        { label: "Motorized", value: "motorized", title: "Motor" },
        { label: "Manual", value: "manual", title: "Manual" }
    ];

    // Motor Type Options by IndoorMotorType
    const motorTypeOptions: PortalShadeOptionItem<IndoorMotorType>[] = [
        { label: "POE", value: "poe", title: "POE" },
        { label: "High Voltage", value: "high_voltage", title: "High Voltage" },
        { label: "Low Voltage HW", value: "low_voltage_hw", title: "Low Voltage HW" },
        { label: "Battery", value: "low_voltage", title: "Low Voltage" },
        { label: "POE Gen 2", value: "poe 2", title: "POE Gen2" }
    ];

    // Manual Type Options by IndoorManualChain
    const manualTypeOptions: PortalShadeOptionItem<IndoorManualChain>[] = [
        { label: "Metal Chain", value: "metal", title: "Metal" },
        { label: "Plastic Chain", value: "plastic", title: "Plastic" },
        { label: "Spring Pull", value: "spring", title: "Spring" }
    ];

    // Indoor Hembar type by IndoorHembarType
    const hembarTypeOptions: PortalShadeOptionItem<IndoorHembarType>[] = [
        { label: "Internal Sealed", value: "internal_sealed", title: "Internal Sealed" },
        { label: "Internal Oval", value: "internal_oval", title: "Internal Oval" },
        { label: "External Metal", value: "external_metal", title: "External Metal" },
        { label: "External Handle", value: "external_handle", title: "External Handle" , isActive: (isSpring) },
        // { label: "Internal Oval Fabric Wrapped", value: "internal_oval_fabric_wrapped", title: "Internal Oval Fabric Wrapped" },
        { label: "Internal Magnetic", value: "internal_magnetic", title: "Internal Magnetic" },
        { label: "Internal Oval Magnetic", value: "oval_magnetic", title: "Oval Magnetic" },
        { label: "External Magnetic", value: "external_magnetic", title: "External Magnetic" }
    ]

    // Indoor Hembar color by IndoorHembarColor
    const hembarColorOptions: PortalShadeOptionItem<IndoorHembarColor>[] = [
        { label: "White", value: "White", title: "White" },
        { label: "Black", value: "Black", title: "Black" },
        { label: "Anodized", value: "Anodized", title: "Anodized" }
    ]

    // Indoor Power Supply by IndoorLvPowerSource
    const lvPowerSupplyOptions: PortalShadeOptionItem<IndoorLvPowerSource>[] = [
        { label: "Wall Charger", value: "wall_charger", title: "Wall Charger" },
        { label: "DC Whip", value: "dc_whip", title: "DC Whip" }
    ]

    const isMetalChain = assembly.shades[0]?.manual_chain === "metal";

    // Indoor Chain Color by IndoorManualChainColor
    // type IndoorManualChainColor = 'Off-White' | 'Grey' | 'Brown' | 'White' | 'Black' | 'Stainless Steel';
    const manualChainColorOptions: PortalShadeOptionItem<IndoorManualChainColor>[] = [
        { label: "Off-White", value: "Off-White", title: "Off-White", isActive: !isMetalChain },
        { label: "Grey", value: "Grey", title: "Grey", isActive: !isMetalChain  },
        { label: "Brown", value: "Brown", title: "Brown", isActive: !isMetalChain },
        { label: "White", value: "White", title: "White", isActive: true},
        { label: "Black", value: "Black", title: "Black", isActive: true },
        { label: "Stainless Steel", value: "Stainless Steel", title: "Stainless Steel", isActive: isMetalChain || allOptionOverride }
    ]

    // Control Side by IndoorControlSide
    const controlSideOptions: PortalShadeOptionItem<IndoorControlSide>[] = [
        { label: "Left", value: "Left", title: "Left" },
        { label: "Right", value: "Right", title: "Right" }
    ]

    const isAc = assembly.shades[0]?.motor_type === "high_voltage";
    const isPoe = assembly.shades[0]?.motor_type === "poe" || assembly.shades[0]?.motor_type === "poe 2";

    const isManual = assembly.shades[0]?.shade_type === "manual";

    const isAcPoeOrManual = isAc || isPoe || isManual;
    const isMotorizedAndDual = isMotorized && is_dual;
    // Header Type by IndoorHeaderType
    const headerTypeOptions: PortalShadeOptionItem<IndoorHeaderType>[] = [
        // OR Medium on all shade config types
        { label: "Open Roll Medium", value: "OR_1234", title: "Open Roll Medium" },
        // OR Small is only on manual shades
        { label: "Open Roll Small", value: "OR_0002", title: "Open Roll Small", isActive: !isMotorized },
        // OR Large Coulisse is only on single shades
        { label: "Open Roll Large (Single)", value: "OR_COULLISE_LARGE_BALANCED", title: "Open Roll Large (Single)", isActive: !is_dual },
        // OR Large ZMC is only on dual shades
        { label: "Open Roll Large (Dual)", value: "OR_5678", title: "Open Roll Large (Dual)", isActive: is_dual },
        // OR Extra Large is only on ps admins or already selected.
        { label: "Open Roll Extra Large", value: "OR_9876", title: "Open Roll Extra Large", isActive: isPsAdmin || assembly.header_type === "OR_9876" },
        // Round Fabric Insert Cassette is only on single shades
        { label: "Round Fabric Insert Cassette 3 in. Anodized", value: "RC3051-A", title: "Round Fabric Insert Cassette 3 in. Anodized", isActive: !is_dual },
        { label: "Round Fabric Insert Cassette 3 in. Black", value: "RC3051-BK", title: "Round Fabric Insert Cassette 3 in. Black", isActive: !is_dual },
        { label: "Round Fabric Insert Cassette 3 in. Bronze", value: "RC3051-DBR", title: "Round Fabric Insert Cassette 3 in. Bronze", isActive: !is_dual },
        { label: "Round Fabric Insert Cassette 3 in. Off-White", value: "RC3051-LB", title: "Round Fabric Insert Cassette 3 in. Off-White", isActive: !is_dual },
        { label: "Round Fabric Insert Cassette 3 in. White", value: "RC3051-W", title: "Round Fabric Insert Cassette 3 in. White", isActive: !is_dual },
        { label: "Round Fabric Insert Cassette 3 in. Anthracite", value: "RC3051-AN", title: "Round Fabric Insert Cassette 3 in. Anthracite", isActive: !is_dual },
        // Square Cassette is only on single shades
        { label: "Square Cassette 3 in. Anodized", value: "RC3029-A", title: "Square Cassette 3 in. Anodized", isActive: !is_dual },
        { label: "Square Cassette 3 in. White", value: "RC3029-W", title: "Square Cassette 3 in. White", isActive: !is_dual },
        // These are disabled except for people who already had the header type.
        { label: "Square Cassette 3 in. Black", value: "RC3029-BK", title: "Square Cassette 3 in. Black", isActive: !is_dual && assembly.header_type === "RC3029-BK" },
        { label: "Square Cassette 3 in. Off-White", value: "RC3029-LB", title: "Square Cassette 3 in. Off-White", isActive: !is_dual && assembly.header_type === "RC3029-LB" },
        // Flat Fabric Wrapped Cassette is only on single shades
        { label: "Flat Fabric Wrapped Cassette 3 in. Black", value: "RB88-0150-050490", title: "Flat Fabric Wrapped Cassette 3 in. Black", isActive: !is_dual },
        { label: "Flat Fabric Wrapped Cassette 3 in. White", value: "RB88-0150-069490", title: "Flat Fabric Wrapped Cassette 3 in. White", isActive: !is_dual },
        { label: "Flat Fabric Wrapped Cassette 3 in. Anodized", value: "RB88-0150-020490", title: "Flat Fabric Wrapped Cassette 3 in. Anodized", isActive: !is_dual },
        { label: "Flat Fabric Wrapped Cassette 3 in. Bronze", value: "RB88-0150-080490", title: "Flat Fabric Wrapped Cassette 3 in. Bronze", isActive: !is_dual },
        { label: "Flat Fabric Wrapped Cassette 3 in. Off-White", value: "RB88-0150-414490", title: "Flat Fabric Wrapped Cassette 3 in. Off-White", isActive: !is_dual },
        // Fascia 3 in. is only on single shades
        { label: "Fascia 3 in. Anodized", value: "RC3080-A", title: "Fascia 3 in. Anodized", isActive: !is_dual },
        { label: "Fascia 3 in. Anthracite", value: "RC3080-AN", title: "Fascia 3 in. Anthracite", isActive: !is_dual },
        { label: "Fascia 3 in. Black", value: "RC3080-BK", title: "Fascia 3 in. Black", isActive: !is_dual },
        { label: "Fascia 3 in. Bronze", value: "RC3080-DBR", title: "Fascia 3 in. Bronze", isActive: !is_dual },
        { label: "Fascia 3 in. Off-White", value: "RC3080-LB", title: "Fascia 3 in. Off-White", isActive: !is_dual },
        { label: "Fascia 3 in. White", value: "RC3080-W", title: "Fascia 3 in. White", isActive: !is_dual },
        // Fascia 5 inch can be on all shade types
        { label: "Fascia 5 in. Anodized", value: "RC4039-A", title: "Fascia 5 in. Anodized" },
        { label: "Fascia 5 in. Anthracite", value: "RC4039-AN", title: "Fascia 5 in. Anthracite" },
        { label: "Fascia 5 in. Black", value: "RC4039-BK", title: "Fascia 5 in. Black" },
        { label: "Fascia 5 in. Bronze", value: "RC4039-DBR", title: "Fascia 5 in. Bronze" },
        { label: "Fascia 5 in. Off-White", value: "RC4039-LB", title: "Fascia 5 in. Off-White" },
        { label: "Fascia 5 in. White", value: "RC4039-W", title: "Fascia 5 in. White" },
        // Cassette 4 inch can only on AC,POE ,or Manual, and also only on single shades
        { label: "Cassette 4 in. White", value: "RS-SU1", title: "Cassette 4 in. White", isActive: isAcPoeOrManual && !is_dual },
        { label: "Cassette 4 in. Bronze", value: "RS-SU2", title: "Cassette 4 in. Bronze", isActive: isAcPoeOrManual && !is_dual },
        { label: "Cassette 4 in. Alabaster", value: "RS-SU3", title: "Cassette 4 in. Alabaster", isActive: isAcPoeOrManual && !is_dual },
        { label: "Cassette 4 in. Anodized", value: "RS-SU4", title: "Cassette 4 in. Anodized", isActive: isAcPoeOrManual && !is_dual },
        { label: "Cassette 4 in. Black", value: "RS-SU5", title: "Cassette 4 in. Black", isActive: isAcPoeOrManual && !is_dual },
        // Fascia 4 inch ZMC is disallowed unless it's a bidspec order and POE/AC/Manual and not dual
        { label: "ZMC Fascia 4 in. White", value: "RS-SC1", title: "Fascia 4 in. White", isActive: isAcPoeOrManual && !is_dual && isBidspec },
        { label: "ZMC Fascia 4 in. Bronze", value: "RS-SC2", title: "Fascia 4 in. Bronze", isActive: isAcPoeOrManual && !is_dual && isBidspec },
        { label: "ZMC Fascia 4 in. Alabaster", value: "RS-SC3", title: "Fascia 4 in. Alabaster", isActive: isAcPoeOrManual && !is_dual && isBidspec },
        { label: "ZMC Fascia 4 in. Anodized", value: "RS-SC4", title: "Fascia 4 in. Anodized", isActive: isAcPoeOrManual && !is_dual && isBidspec },
        { label: "ZMC Fascia 4 in. Black", value: "RS-SC5", title: "Fascia 4 in. Black", isActive: isAcPoeOrManual && !is_dual && isBidspec },
        // Fascia 5.5 inch ZMC is disallowed unless it's a bidspec order and POE/AC/Manual and not dual
        { label: "ZMC Fascia 5.5 in. Anodized", value: "RS-SV4", title: "Fascia 5.5 in. Anodized", isActive: isAcPoeOrManual && !is_dual && isBidspec },
        { label: "ZMC Fascia 5.5 in. Bronze", value: "RS-SV2", title: "Fascia 5.5 in. Bronze", isActive: isAcPoeOrManual && !is_dual && isBidspec },
        { label: "ZMC Fascia 5.5 in. White", value: "RS-SV1", title: "Fascia 5.5 in. White", isActive: isAcPoeOrManual && !is_dual && isBidspec },
        // ZMC 7 inch fascia is only for motorized dual shades
        { label: "Fascia 7 in. Anodized", value: "RS-SK4A", title: "Fascia 7 in. Anodized", isActive: isMotorized },
        { label: "Fascia 7 in. Black", value: "RS-SK5A", title: "Fascia 7 in. Black", isActive: isMotorized },
        { label: "Fascia 7 in. Bronze", value: "RS-SK2A", title: "Fascia 7 in. Bronze", isActive: isMotorized },
        { label: "Fascia 7 in. White", value: "RS-SK1A", title: "Fascia 7 in. White", isActive: isMotorized },
        // Only on motorized dual shades on bidspec
        { label: "(ZMC) Open Roll Large", value: "OR_ZMC_LARGE", title: "(ZMC) Open Roll Large", isActive: isMotorizedAndDual && isBidspec },
        // COU 4 inch cannot work with dual shades
        { label: "Fascia 4 in. Anodized", value: "RC3158-A", title: "Fascia 4 in. Black", isActive: !is_dual },
        { label: "Fascia 4 in. Anthracite", value: "RC3158-AN", title: "Fascia 4 in. Anthracite", isActive: !is_dual },
        { label: "Fascia 4 in. Black", value: "RC3158-BK", title: "Fascia 4 in. Black", isActive: !is_dual },
        { label: "Fascia 4 in. Bronze", value: "RC3158-DBR", title: "Fascia 4 in. Bronze", isActive: !is_dual },
        { label: "Fascia 4 in. Off-White", value: "RC3158-LB", title: "Fascia 4 in. Off-White", isActive: !is_dual },
        { label: "Fascia 4 in. White", value: "RC3158-W", title: "Fascia 4 in. White", isActive: !is_dual },
    ];

    //type IndoorBalancedLightgaps = 'balanced' | 'unbalanced';
    // Balanced Light Gaps by IndoorBalancedLightgaps
    const balancedLightGapsOptions: PortalShadeOptionItem<IndoorBalancedLightgaps>[] = [
        { label: "Balanced", value: "True", title: "Balanced" },
        { label: "Unbalanced", value: "False", title: "Unbalanced" }
    ];

    const isEndCapsMetal = assembly?.end_caps?.includes("Metal End Caps") ?? false;
    const isEndCapsPlastic = assembly?.end_caps?.includes("Plastic End Caps") ?? false;
    const isExternalMetalHembar = assembly?.shades[0]?.hembar_type?.includes("external_metal") ?? false;

    // Hardware Color by IndoorHardwareColor
    const hardwareColorOptions: PortalShadeOptionItem<IndoorHardwareColor>[] = [
        { label: "Black", value: "Black", title: "Black", isActive: isEndCapsPlastic },
        { label: "White", value: "White", title: "White", isActive: (isEndCapsMetal && !isExternalMetalHembar) || isEndCapsPlastic },
        { label: "Anodized", value: "Anodized", title: "Anodized", isActive: isEndCapsPlastic },
        { label: "Bronze", value: "Bronze", title: "Bronze", isActive: isEndCapsPlastic },
        { label: "Grey", value: "Grey", title: "Grey", isActive: isEndCapsPlastic },
        { label: "Off-White", value: "Off-White", title: "Off-White", isActive: isEndCapsPlastic },
        { label: "Anthracite", value: "Anthracite", title: "Anthracite", isActive: isEndCapsPlastic },
        { label: "Black Nickel", value: "Black Nickel", title: "Black Nickel", isActive: isEndCapsMetal },
        { label: "Chrome", value: "Chrome", title: "Chrome", isActive: isEndCapsMetal && !isExternalMetalHembar },
        { label: "Natural Aluminum", value: "Natural Aluminum", title: "Natural Aluminum", isActive: isEndCapsMetal && !isExternalMetalHembar },
        { label: "Old Brass", value: "Old Brass", title: "Old Brass", isActive: isEndCapsMetal && !isExternalMetalHembar },
        { label: "Stainless Steel", value: "Stainless Steel", title: "Stainless Steel", isActive: isEndCapsMetal && !isExternalMetalHembar }
    ];

    // Endcap Options by IndoorEndCaps
    const endCapOptions: PortalShadeOptionItem<IndoorEndCaps>[] = [
        { label: "Metal End Caps", value: "Metal End Caps", title: "Metal End Caps" },
        { label: "Plastic End Caps", value: "Plastic End Caps", title: "Plastic End Caps" }
    ];

    // Set assembly partial for easy updates
    const setAssemblyPartial = (newAssembly: Partial<AssemblyStore>) => {
        setAssemblyInit({
            ...assembly,
            ...newAssembly
        });
    }

    const isRoundFabricCassette = assembly.header_type?.includes("RC3051");
    const isExternalOrOvalHembar = assembly.shades[0]?.hembar_type?.includes("external") || assembly.shades[0]?.hembar_type?.includes("oval");

    const isLVBattery = assembly.shades[0]?.motor_type === "low_voltage";

    // Fascia is RC3080,RC4039, RC3158, RS-SK, RS-SC, RS-SV
    const isFascia = (headerType = "") => headerType.includes("RC3080") || headerType.includes("RC4039") || headerType.includes("RC3158") || headerType.includes("RS-SK") || headerType.includes("RS-SC") || headerType.includes("RS-SV");
    const isCassette = (headerType = "") => headerType.includes("RS-SU") || headerType.includes("RC3029") || headerType.includes("RC3051") || (headerType.includes("RB88-0150-") && headerType.includes("490"));

    const bandCount = assembly?.band_count == 0 ? 1 : assembly?.band_count ?? 1;
    const totalWidth = assembly?.total_width ?? assembly?.shades?.find(s => s.row_coordinate == 0 && s.column_coordinate == 0)?.width ?? 0;

    const isInsideMount = assembly.mount_type === "Inside";
    const isFabricWidthMount = assembly.mount_type === "Fabric Width";

    const widthInfo = (() => {
        if (totalWidth === 0) return [];
        const variableAmount = bandCount % 8;
        const bigNumberAmount = bandCount / 8;

        const bigNumberString = bigNumberAmount > 0 ? `${bigNumberAmount}` : '';
        const variableString = variableAmount > 0 ? `${variableAmount}/8` : '';

        let variableEigths = '';

        if (bigNumberAmount > 0) {
            variableEigths += bigNumberString;
        }

        if (bigNumberAmount > 0 && variableAmount > 0) {
            variableEigths += ' ';
        }

        if (variableAmount > 0) {
            variableEigths += variableString;
        }

        let widthString = `${totalWidth - bigNumberAmount} - ${totalWidth}`;

        if (!isInsideMount) {
            variableEigths = `${variableEigths}`;
            widthString = `${totalWidth} - ${totalWidth + bigNumberAmount}`;
        }

        let bracketString = `Actual Width (Bracket to Bracket):`;

        if (isFabricWidthMount) {
            bracketString = `Actual Width (Fabric edge to Fabric edge):`;
        }

        return [bracketString, `${widthString}`];
    })()


    const allDict: IndoorShadeOptionsAllDict = {
        HeaderMountType: {
            label: "Mount Type",
            options: headerMountOptions,
            clearValue: () => {
                setAssemblyPartial({
                    mount_type: ""
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    mount_type: value
                });
            },
            getSelectedOption: () => headerMountOptions.find(opt => opt.value?.toLowerCase() === assembly.mount_type?.toLowerCase()) as PortalShadeOptionItem<IndoorMountType>,
            varName: "mount_type",
            error: [],
            getValue: () => assembly.mount_type as IndoorMountType,
            valuePopup: isInsideMount ? InsideMount :
                        isFabricWidth ? FabricWidth : OutsideMount,
            info: isInsideMount ? ["PowerShades advises measuring down to a 1/16” of an inch and subtracting 1/8” of an inch off the measurement from the top of the window for an inside mount. Please note that measurements may vary between the front and back of the window jamb. The 1/8” of an inch is to be taken from the narrowest measurement obtained."] : []
        },
        ShadeConfiguration: {
            label: "Shade Configuration",
            options: shadeConfigurationOptions,
            clearValue: () => {
                setAssemblyPartial({
                    is_dual: false,
                    is_coupled: false,
                    band_count: 1,
                    shades: [assembly?.shades?.find(cs => cs.row_coordinate == 0 && cs.column_coordinate == 0) ?? InitialShadeState()]
                });
            },
            setValue: (value) => {
                const currentShades = assembly?.shades ?? [InitialShadeState()];
                const hasBackRow = currentShades.some(cs => cs.row_coordinate == 1);
                const hasCoupledShades = currentShades.some(cs => cs.column_coordinate > 0);

                const isCurrentCoupled = assembly?.is_coupled ?? false;
                const isCurrentDual = assembly?.is_dual ?? false;

                if (
                    !isCurrentCoupled && !isCurrentDual && value === 'single'
                    || !isCurrentCoupled && isCurrentDual && value === 'dual'
                    || isCurrentCoupled && !isCurrentDual && value === 'single coupled'
                    || isCurrentCoupled && isCurrentDual && value === 'dual coupled'

                ) {
                    return;
                }

                if (value === "dual") {
                    // From Single
                    let newShades = [...currentShades, ...currentShades.map(s => ({ ...s, row_coordinate: 1 }))]

                    if (hasBackRow && hasCoupledShades) {
                        // From Dual Coupled
                        newShades = currentShades.filter(s => s.column_coordinate == 0);
                    } else if (hasCoupledShades) {
                        // From Single Coupled
                        let firstShade = currentShades.find(s => s.column_coordinate == 0 && s.row_coordinate == 0) ?? InitialShadeState();
                        newShades = [firstShade, { ...firstShade, row_coordinate: 1 }];
                    }

                    setAssemblyPartial({
                        is_dual: true,
                        is_coupled: false,
                        band_count: 1,
                        shades: newShades
                    });
                } else if (value === "single coupled") {
                    // From Single
                    let newShades: ShadeStore[] = [...currentShades, { ...currentShades[0]!, column_coordinate: 1 }];
                    let bandCount = 2;

                    if (hasBackRow && hasCoupledShades) {
                        // From Dual Coupled
                        newShades = currentShades.filter(s => s.row_coordinate == 0);
                        bandCount = newShades.length ?? 1;
                    } else if (hasBackRow) {
                        // From Dual
                        const frontFirstShade = currentShades.find(s => s.row_coordinate == 0 && s.column_coordinate == 0) ?? InitialShadeState();
                        newShades = [frontFirstShade, { ...frontFirstShade, column_coordinate: 1 }];
                    }
                    setAssemblyPartial({
                        is_dual: false,
                        is_coupled: true,
                        band_count: bandCount,
                        shades: newShades
                    });
                } else if (value === "dual coupled") {

                    // From Single
                    let frontShade = currentShades.find(a => a.row_coordinate == 0) ?? InitialShadeState();
                    let newBackShade = { ...frontShade, row_coordinate: 1 };
                    let newShades = [frontShade, newBackShade, { ...frontShade, column_coordinate: 1 }, { ...newBackShade, column_coordinate: 1 }];
                    let bandCount = currentShades.filter(cs => cs.row_coordinate == 0).length;

                    if (hasBackRow) {
                        // From Dual
                        const currentBackShade = currentShades.find(cs => cs.row_coordinate == 1 && cs.column_coordinate == 0) ?? InitialShadeState();
                        newShades = [frontShade, currentBackShade, { ...frontShade, column_coordinate: 1 }, { ...currentBackShade, column_coordinate: 1 }];
                    } else if (hasCoupledShades) {
                        // From Single Coupled
                        newShades = [...currentShades, ...currentShades.map(cs => ({ ...cs, row_coordinate: 1 }))];
                    }

                    setAssemblyPartial({
                        is_dual: true,
                        is_coupled: true,
                        band_count: bandCount,
                        shades: newShades
                    });
                    // TO single
                } else {
                    setAssemblyPartial({
                        is_dual: false,
                        is_coupled: false,
                        band_count: 1,
                        shades: [currentShades.find(cs => cs.row_coordinate == 0 && cs.column_coordinate == 0) ?? InitialShadeState()]
                    });
                }
            },
            getSelectedOption: () => (assembly.is_coupled && assembly.is_dual ? shadeConfigurationOptions[3] // dual coupled
                : assembly.is_coupled ? shadeConfigurationOptions[2] // single coupled
                    : assembly.is_dual ? shadeConfigurationOptions[1] // dual
                        : shadeConfigurationOptions[0]) as PortalShadeOptionItem<IndoorShadeConfiguration>,  // single
            varName: "shade_configuration",
            error: [],
            info: [],
            getValue: () => assembly.is_coupled && assembly.is_dual ? "dual coupled"
                : assembly.is_coupled ? "single coupled"
                    : assembly.is_dual ? "dual"
                        : "single",

        },
        DirectionFacing: {
            label: "Direction Facing",
            options: directionFacingOptions,
            clearValue: () => {
                setAssemblyPartial({
                    direction_facing: ""
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    direction_facing: value
                });
            },
            getSelectedOption: () => directionFacingOptions.find(opt => opt.value === assembly.direction_facing) as PortalShadeOptionItem<string>,
            varName: "direction_facing",
            error: [],
            info: [],
            getValue: () => assembly.direction_facing,

        },
        RoomName: {
            label: "Room Name",
            options: [],
            clearValue: () => {
                setAssemblyPartial({
                    room_name: ""
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    room_name: value
                });
            },
            getSelectedOption: () => { return { label: "", value: "", title: "" } },
            varName: "room_name",
            error: [],
            info: [],
            getValue: () => assembly.room_name,
        },
        ShadeName: {
            label: "Shade Name",
            options: [],
            clearValue: () => {
                setAssemblyPartial({
                    shade_name: ""
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    shade_name: value
                });
            },
            getSelectedOption: () => { return { label: "", value: "", title: "" } },
            varName: "shade_name",
            error: [],
            info: [],
            getValue: () => assembly.shade_name,
        },
        Floor: {
            label: "Floor",
            options: [],
            clearValue: () => {
                setAssemblyPartial({
                    floor: 0
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    floor: value
                });
            },
            getSelectedOption: () => { return { label: "", value: 0, title: "" } },
            varName: "floor",
            error: [],
            info: [],
            getValue: () => assembly.floor,
        },
        SideChannels: {
            label: "Side Channels",
            options: sideChannelOptions,
            clearValue: () => {
                setAssemblyPartial({
                    side_channels: "None"
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    side_channels: value
                });
            },
            getSelectedOption: () => sideChannelOptions.find(opt => opt.value === assembly.side_channels) ?? sideChannelOptions[0] as PortalShadeOptionItem<IndoorSideChannels>,
            varName: "side_channels",
            error: [],
            info: [],
            getValue: () => (assembly.side_channels == "") ? "None" : assembly.side_channels as IndoorSideChannels,
            active: !(isExternalOrOvalHembar || isRoundFabricCassette),
            valuePopup: assembly?.side_channels === "Both" ? SideAndSill :
                        assembly?.side_channels === "Sill" ? SillPlate :
                        assembly?.side_channels === "Side" ? SideChannels :null

        },
        SideChannelsColor: {
            label: "Side Channels Color",
            options: sideChannelColorOptions,
            clearValue: () => {
                setAssemblyPartial({
                    side_channels_color: ""
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    side_channels_color: value
                });
            },
            getSelectedOption: () => sideChannelColorOptions.find(opt => opt.value === assembly.side_channels_color) as PortalShadeOptionItem<IndoorSideChannelsColor>,
            varName: "side_channels_color",
            error: [],
            info: [],
            getValue: () => assembly.side_channels_color as IndoorSideChannelsColor,
            active: (assembly.side_channels !== "None" && assembly.side_channels !== "") && !(isExternalOrOvalHembar || isRoundFabricCassette)
        },
        DriveType: {
            label: "Shade Type",
            options: driveTypeOptions,
            clearValue: () => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        shade_type: ""
                    }))
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        shade_type: value
                    }))
                });
            },
            getSelectedOption: () => driveTypeOptions.find(opt => opt.value === assembly.shades[0]?.shade_type) as PortalShadeOptionItem<IndoorDriveType>,
            varName: "drive_type",
            error: [],
            info: [],
            getValue: () => assembly.shades[0]?.shade_type as IndoorDriveType,
            valuePopup: isMotorized ? MotorizedShade :
                        ManualShade
        },
        MotorType: {
            label: "Motor Type",
            options: motorTypeOptions,
            clearValue: () => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        motor_type: ""
                    }))
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        motor_type: value
                    }))
                });
            },
            getSelectedOption: () => motorTypeOptions.find(opt => opt.value === assembly.shades[0]?.motor_type) as PortalShadeOptionItem<IndoorMotorType>,
            varName: "motor_type",
            error: [],
            info: [],
            getValue: () => assembly.shades[0]?.motor_type as IndoorMotorType,
            active: !isManual,
            valuePopup: isPoe ? PoE :
                        isLVBattery ? Battery :
                        isAc ? AC :
                        DC
        },
        ManualType: {
            label: "Manual Type",
            options: manualTypeOptions,
            clearValue: () => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        manual_chain: ""
                    }))
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        manual_chain: value
                    }))
                });
            },
            getSelectedOption: () => manualTypeOptions.find(opt => opt.value === assembly.shades[0]?.manual_chain) as PortalShadeOptionItem<IndoorManualChain>,
            varName: "manual_chain",
            error: [],
            info: [],
            getValue: () => assembly.shades[0]?.manual_chain as IndoorManualChain,
            active: !isMotorized,
            valuePopup: isSpring ? SpringPull : ManualShade
        },
        TotalWidth: {
            label: is_coupled ? "Total Width" : "Width",
            options: [],
            clearValue: () => {
                setAssemblyPartial({
                    total_width: 0
                });

                if (!assembly.is_coupled) {
                    setAssemblyPartial({
                        shades: assembly.shades.map(s => ({
                            ...s,
                            width: 0
                        }))
                    });
                }

            },
            setValue: (value) => {
                if (assembly.is_coupled) {
                    setAssemblyPartial({
                        total_width: value
                    });
                } else {
                    setAssemblyPartial({
                        total_width: value,
                        shades: assembly.shades.map(s => ({
                            ...s,
                            width: value
                        }))
                    });
                }
            },
            getSelectedOption: () => { return { label: "", value: 0, title: "" } },
            varName: "width",
            error: [],
            info: widthInfo,
            getValue: () => !assembly?.is_coupled ? assembly.shades[0]?.width ?? 0 : assembly.total_width,
            minValue: 6,
            maxValue: 240
        },
        Height: {
            label: "Height",
            options: [],
            clearValue: () => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        height: 0
                    }))
                });


            },
            setValue: (value) => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        height: value
                    }))
                });
            },
            getSelectedOption: () => { return { label: "", value: 0, title: "" } },
            varName: "height",
            error: [],
            info: [],
            getValue: () => assembly.shades[0]?.height ?? 0,
            maxValue: 240,
            minValue: 0
        },
        WindowJambDepth: {
            label: "Window Jamb Depth",
            options: [],
            clearValue: () => {
                setAssemblyPartial({
                    window_jamb_depth: 0
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    window_jamb_depth: value
                });
            },
            getSelectedOption: () => { return { label: "", value: 0, title: "" } },
            varName: "window_jamb_depth",
            error: [],
            info: [],
            getValue: () => assembly.window_jamb_depth,
            maxValue: 240,
            minValue: 0,
            active: isInsideMount
        },
        HembarType: {
            label: "Hembar Type",
            options: hembarTypeOptions,
            clearValue: () => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        hembar_type: ""
                    }))
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        hembar_type: value
                    }))
                });
            },
            getSelectedOption: () => hembarTypeOptions.find(opt => opt.value === assembly.shades[0]?.hembar_type) as PortalShadeOptionItem<IndoorHembarType>,
            varName: "hembar_type",
            error: [],
            info: [],
            getValue: () => assembly.shades[0]?.hembar_type as IndoorHembarType,
            valuePopup: assembly.shades[0]?.hembar_type?.includes("magnet") ? HembarWithMagnet :
                        assembly.shades[0]?.hembar_type?.includes("external") ? ExternalHembar :
                        assembly.shades[0]?.hembar_type?.includes("oval") ? InternalRoundedHembar : 
                        assembly.shades[0]?.hembar_type?.includes("internal_sealed") ? InternalFlatHembar : null
        },
        HembarColor: {
            label: "Hembar Color",
            options: hembarColorOptions,
            clearValue: () => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        hembar_color: ""
                    }))
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        hembar_color: value
                    }))
                });
            },
            getSelectedOption: () => hembarColorOptions.find(opt => opt.value === assembly.shades[0]?.hembar_color) as PortalShadeOptionItem<IndoorHembarColor>,
            varName: "hembar_color",
            error: [],
            info: [],
            getValue: () => assembly.shades[0]?.hembar_color as IndoorHembarColor,
            active: false
        },
        LVPowerSupply: {
            label: "LV Power Supply",
            options: lvPowerSupplyOptions,
            clearValue: () => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        lv_power_source: ""
                    }))
                });

            },
            setValue: (value) => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        lv_power_source: value
                    }))
                });
            },
            getSelectedOption: () => lvPowerSupplyOptions.find(opt => opt.value === assembly.shades[0]?.lv_power_source) as PortalShadeOptionItem<IndoorLvPowerSource>,
            varName: "lv_power_source",
            error: [],
            info: [],
            getValue: () => assembly.shades[0]?.lv_power_source as IndoorLvPowerSource,
            active: isLVBattery && !isManual
        },
        ManualChainColor: {
            label: "Manual Chain Color",
            options: manualChainColorOptions,
            clearValue: () => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        manual_chain_color: ""
                    }))
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    shades: assembly.shades.map(s => ({
                        ...s,
                        manual_chain_color: value
                    }))
                });
            },
            getSelectedOption: () => manualChainColorOptions.find(opt => opt.value === assembly.shades[0]?.manual_chain_color) as PortalShadeOptionItem<IndoorManualChainColor>,
            varName: "manual_chain_color",
            error: [],
            info: [],
            getValue: () => assembly.shades[0]?.manual_chain_color as IndoorManualChainColor,
            active: !isMotorized && !isSpring
        },
        ControlSide: {
            label: is_dual ? "Inside Control Side" : "Control Side",
            options: controlSideOptions,
            clearValue: () => {
                setAssemblyPartial({
                    control_side: ""
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    control_side: value
                });
            },
            getSelectedOption: () => controlSideOptions.find(opt => opt.value === assembly.control_side) as PortalShadeOptionItem<IndoorControlSide>,
            varName: "control_side",
            error: [],
            info: [],
            getValue: () => assembly.control_side as IndoorControlSide,
            valuePopup: assembly.control_side === "Left" ? LeftControl : RightControl


        },
        HeaderType: {
            label: "Header Type",
            options: headerTypeOptions,
            clearValue: () => {
                setAssemblyPartial({
                    header_type: ""
                });
            },
            setValue: (value) => {
                if (isFascia(value)) {
                    setAssemblyPartial({
                        header_type: value,
                        end_caps: "Fascia End Caps"
                    });
                } else if (isCassette(value)) {
                    setAssemblyPartial({
                        header_type: value,
                        end_caps: "Plastic End Caps"
                    });
                } else {
                    setAssemblyPartial({
                        header_type: value
                    });
                }
            },
            getSelectedOption: () => headerTypeOptions.find(opt => opt.value === assembly.header_type) as PortalShadeOptionItem<IndoorHeaderType>,
            varName: "header_type",
            error: [],
            info: [],
            getValue: () => assembly.header_type as IndoorHeaderType,
            valuePopup: assembly.header_type?.includes("RC3080") && !is_dual ? Fascia_3_Single :
                        assembly.header_type?.includes("RC4039") && is_dual  ? Fascia_5_Dual :
                        assembly.header_type?.includes("RC4039") && !is_dual  ? Fascia_5_Single :
                        assembly.header_type?.includes("RS-SK") ? Fascia_7_Dual :
                        assembly.header_type?.includes("OR_1234") && !is_dual ? Open_Roll_Medium_Single :
                        assembly.header_type?.includes("OR_1234") && is_dual ? Open_Roll_Medium_Dual :
                        assembly.header_type?.includes("OR_0002") ? Open_Roll_Small_Single :
                        assembly.header_type?.includes("OR_5678") && !is_dual ? Open_Roll_Large_Single :
                        assembly.header_type?.includes("OR_5678") && is_dual ? Open_Roll_Large_Dual :
                        assembly.header_type?.includes("RC3051") ? Cassette_3_FW_Single : null




        },
        BalancedLightGaps: {
            label: "Balanced Light Gaps",
            options: balancedLightGapsOptions,
            clearValue: () => {
                setAssemblyPartial({
                    balanced_lightgaps: "True"
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    balanced_lightgaps: value
                });
            },
            getSelectedOption: () => balancedLightGapsOptions.find(opt => opt.value === assembly.balanced_lightgaps) as PortalShadeOptionItem<IndoorBalancedLightgaps>,
            varName: "balanced_light_gaps",
            error: [],
            info: [],
            getValue: () => assembly.balanced_lightgaps as IndoorBalancedLightgaps,
            active: false
        },
        HardwareColor: {
            label: "Hardware Color",
            options: hardwareColorOptions,
            clearValue: () => {
                setAssemblyPartial({
                    hardware_color: ""
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    hardware_color: value
                });
            },
            getSelectedOption: () => hardwareColorOptions.find(opt => opt.value === assembly.hardware_color) as PortalShadeOptionItem<IndoorHardwareColor>,
            varName: "hardware_color",
            error: [],
            info: [],
            getValue: () => assembly.hardware_color as IndoorHardwareColor,
            active: !isFascia(assembly.header_type) && !isCassette(assembly.header_type)

        },
        EndCaps: {
            label: "End Caps",
            options: endCapOptions,
            clearValue: () => {
                setAssemblyPartial({
                    end_caps: ""
                });
            },
            setValue: (value) => {
                setAssemblyPartial({
                    end_caps: value
                });
            },
            getSelectedOption: () => endCapOptions.find(opt => opt.value === assembly.end_caps) as PortalShadeOptionItem<IndoorEndCaps>,
            varName: "end_caps",
            error: [],
            info: [],
            getValue: () => assembly.end_caps as IndoorEndCaps,
            active: !isFascia(assembly.header_type) && !isCassette(assembly.header_type)
        }
    };

    const dictFull = { ...baseDict, ...allDict };

    Object.values(dictFull).forEach(dict => {
        dict.active = dict.active ?? true;
        dict.options?.forEach((opt) => {
            opt.isActive = opt.isActive ?? true;
        })
    });

    return dictFull;
}

export {
    useNewIndoorShadeOptions,
    useCurrentIndoorShadeOptions
};
